<template>
    <div id="employeedetailpage">
        <actions-menu>
            <actions-menu-item
                :v4="true"
                :action="() => $router.push('/employees')"
                icon="arrow-left"
                :label="trans('pages.employee_detail.to_overview')"
            />
            <template v-if="employee">
                <actions-menu-item
                    :v4="true"
                    :action="
                        () =>
                            $router.push(
                                '/employeeworkhours/?employeeId=' + idParam
                            )
                    "
                    icon="clock-o"
                    :label="trans('pages.employee_detail.work_hours_overview')"
                />
                <actions-menu-item
                    :v4="true"
                    :action="
                        () => $router.push('/employeeperformance/' + idParam)
                    "
                    icon="line-chart"
                    :label="trans('pages.employee_detail.performance')"
                />
                <actions-menu-item
                    :v4="true"
                    :action="() => $router.push('/employeeleave/' + idParam)"
                    icon="plane"
                    :label="trans('pages.employee_detail.change_leave_days')"
                />
                <actions-menu-item
                    :v4="true"
                    :action="() => $router.push('/employeeabsence/' + idParam)"
                    icon="user-times"
                    :label="trans('pages.employee_detail.manage_absences')"
                />
                <actions-menu-item
                    :v4="true"
                    :action="
                        () => $router.push('/editpasswordemployee/' + idParam)
                    "
                    icon="unlock-alt"
                    :label="trans('pages.employee_detail.change_password')"
                />
                <actions-menu-item
                    :v4="true"
                    :action="removeEmployee"
                    class="alert"
                    icon="trash-o"
                    :label="trans('pages.employee_detail.delete')"
                />
                <actions-menu-item
                    :v4="true"
                    :action="printQr"
                    icon="print"
                    :label="trans('pages.employee_detail.print_qr')"
                />
                <actions-menu-item
                    :action="
                        () => $router.push('/timeline/' + $route.params.id)
                    "
                    icon="stream"
                    :label="trans('pages.employee_detail.timeline')"
                />
                <actions-menu-item
                    v-if="isAdmin"
                    :v4="true"
                    :action="
                        () =>
                            $router.push(
                                '/dashboard/?employeeId=' + $route.params.id
                            )
                    "
                    icon="bar-chart"
                    :label="trans('pages.employee_detail.dashboard')"
                />
            </template>
        </actions-menu>

        <template v-if="employee && leaveData && absenceData">
            <div class="employee-qr-code-container">
                <img :src="qrCodeUrl" />
            </div>
            <div class="leftcolumn">
                <div class="row">
                    <h2>{{ trans('pages.employee_detail.details') }}</h2>
                </div>
                <div
                    id="employeefields"
                    v-if="employee"
                >
                    <div class="profilepagefield">
                        <div class="profilepagename">
                            {{ trans('pages.employee_detail.name') }}
                        </div>
                        <div class="profilepagevalue">{{ employee.name }}</div>
                    </div>
                    <div class="profilepagefield">
                        <div class="profilepagename">
                            {{ trans('pages.employee_detail.employee_name') }}
                        </div>
                        <div class="profilepagevalue">
                            {{ employee.employee_name }}
                        </div>
                    </div>
                    <div class="profilepagefield">
                        <div class="profilepagename">
                            {{ trans('pages.employee_detail.employee_code') }}
                        </div>
                        <div class="profilepagevalue">
                            {{ employee.employee_code }}
                        </div>
                    </div>
                    <div class="profilepagefield">
                        <div class="profilepagename">
                            {{ trans('pages.employee_detail.driver') }}
                        </div>
                        <div class="profilepagevalue">
                            {{ boolToYesNo(employee.driver == '1') }}
                        </div>
                    </div>
                </div>
                <h2>{{ trans('pages.employee_detail.leave_days') }}</h2>
                <div class="leave-list">
                    <ul>
                        <li v-if="leaveData.length == 0">
                            {{ trans('pages.employee_detail.no_leave_days') }}
                        </li>
                        <template v-else>
                            <li
                                v-for="(leave, leaveIndex) in leaveData"
                                :key="'leave.' + leaveIndex"
                            >
                                <template v-if="leave.employeeId">
                                    {{ leave.day }}
                                    <small>
                                        {{
                                            trans('pages.employee_detail.from')
                                        }}
                                        {{ leave.startTime }}
                                        {{ trans('pages.employee_detail.to') }}
                                        {{ leave.endTime }}
                                    </small>
                                </template>
                                <template v-else>
                                    <strong>
                                        {{ leave.day }} ({{ leave.name }})
                                    </strong>
                                </template>
                            </li>
                        </template>
                    </ul>
                </div>
                <h2>{{ trans('pages.employee_detail.absences') }}</h2>
                <div class="leave-list">
                    <ul>
                        <li v-if="absenceData.length == 0">
                            {{ trans('pages.employee_detail.no_absences') }}
                        </li>
                        <template v-else>
                            <li
                                v-for="(absence, absenceIndex) in absenceData"
                                :key="'absence.' + absenceIndex"
                            >
                                {{ absence.day }} ({{ absence.reason }})
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import ActionsMenu from '../components/ActionsMenu';
import ActionsMenuItem from '../components/ActionsMenuItem';
import userApi from '../api/user';
import employeeApi from '../api/employee';
import IdParamMixin from '../mixins/id-param';
import OutputHelper from '../helpers/OutputHelper';
import {
    showConfirmDialog,
    showInfoMessage,
    showErrorMessage,
} from '../dialogs';
import { mapGetters } from 'vuex';
import localization from '../mixins/localization';

export default {
    mixins: [IdParamMixin(), localization],
    components: {
        ActionsMenu,
        ActionsMenuItem,
    },
    computed: {
        isAdmin() {
            return this.$store.getters['currentUser/hasRight'](
                'administration'
            );
        },
        selectedPrinterPostParameter() {
            return this.$store.getters[
                'printers/getSelectedPrinterPostParameter'
            ]();
        },
        qrCodeUrl() {
            return Config.url + '/employee/qrCode/?id=' + this.idParam;
        },
    },
    data() {
        return {
            employee: null,
            leaveData: null,
            absenceData: null,
        };
    },
    methods: {
        boolToYesNo: OutputHelper.boolToYesNo,
        load() {
            const employeeId = this.$route.params.id;
            const fullYear = new Date().getFullYear();

            userApi.fetchUserDetails(employeeId).then((response) => {
                const employee = response.data.data;
                this.employee = employee;
                this.$store.commit('general/setPageTitle', employee.name);
            });

            employeeApi
                .fetchAllLeaveForYear(employeeId, fullYear)
                .then((response) => {
                    this.leaveData = response.data.data;
                });

            employeeApi
                .fetchAbsenceForYear(employeeId, fullYear)
                .then((response) => {
                    this.absenceData = response.data.data;
                });
        },
        printQr() {
            if (KeyHelper.isPressed('Shift')) {
                window.open(
                    Config.url +
                        '/employee/exportQrCode/' +
                        '?id=' +
                        this.idParam
                );
            } else {
                employeeApi
                    .printQrCode(
                        this.idParam,
                        this.selectedPrinterPostParameter
                    )
                    .then(() => {
                        showInfoMessage(
                            this.trans('pages.employee_detail.label_printed')
                        );
                    })
                    .catch(() => {
                        showErrorMessage(
                            this.trans('pages.employee_detail.unknown_error')
                        );
                    });
            }
        },
        removeEmployee() {
            showConfirmDialog({
                title: this.trans(
                    'pages.employee_detail.delete_employee_title'
                ),
                content: this.trans(
                    'pages.employee_detail.delete_employee_confirm'
                ),
                confirm: () => {
                    userApi
                        .deleteUser(this.idParam)
                        .then(() => {
                            this.$router.push('/employees');
                            showInfoMessage(
                                this.trans(
                                    'pages.employee_detail.employee_deleted'
                                )
                            );
                        })
                        .catch(() => {
                            showErrorMessage(
                                this.trans(
                                    'pages.employee_detail.employee_delete_error'
                                )
                            );
                        });
                },
                closeOnCancel: true,
                closeOnOk: true,
                confirmButton: this.trans('pages.employee_detail.yes'),
                cancelButton: this.trans('pages.employee_detail.no'),
            });
        },
    },
};
</script>
